import React from "react";
import { Card } from "reactstrap";

import { default as UserDetailsTable } from "./UserDetailsTable";

const UserDetailsCard = (props) => {
  return (
    <Card className="p-2 mt-1">
      <div className="d-flex">
        <div className="flex-grow-1 text-center pb-1">User Information</div>
      </div>
      <UserDetailsTable />
    </Card>
  );
};

export default UserDetailsCard;
